import { BeltRank } from "../../MembersArea";

const DEFAULT_TAB_SURFACE = "!bg-gray-200 !text-gray-900";

interface BalSeakSoProps {
  selectedBelt: BeltRank;
  getBeltColor: (belt: BeltRank) => string;
  hasDemo?: (aliases: string[]) => boolean;
  onWatchDemo?: (aliases: string[]) => void;
  presentation?: "legacy" | "curriculum";
  beltTabSurfaceClass?: string;
}

export default function BalSeakSo({
  selectedBelt,
  getBeltColor: _getBeltColor,
  hasDemo,
  onWatchDemo,
  presentation = "legacy",
  beltTabSurfaceClass: _beltTabSurfaceClass = DEFAULT_TAB_SURFACE,
}: BalSeakSoProps) {
  if (!["BLACK/D1", "BLACK/D2", "BLACK/D3", "BLACK/D4", "BLACK/D5"].includes(selectedBelt)) {
    return null;
  }

  const demoBtn =
    hasDemo?.(["bal_saek_so", "balsaekso", "balsaek_so"]) ? (
      <button
        type="button"
        className="mb-3 inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
        onClick={() => onWatchDemo?.(["bal_saek_so", "balsaekso", "balsaek_so"])}
      >
        Watch Demonstration Video
      </button>
    ) : null;

  const body = (
    <>
      {demoBtn}
      <h4 className="mb-3 text-base font-medium text-taekwondo-red">Pattern Meaning</h4>
      <p className="text-gray-700">
        BalSaekSo represents &quot;Storming the Enemy&apos;s Fortress - Small&quot;. This compact pattern emphasizes quick, decisive movements
        designed to penetrate defensive positions.
      </p>
    </>
  );

  if (presentation === "curriculum") {
    return (
      <div className="rounded-lg bg-gray-50 p-4 md:p-5">
        <h2 className="mb-4 text-lg font-semibold text-taekwondo-red md:text-xl">Storming the enemy fortress (Small)</h2>
        <div>{body}</div>
      </div>
    );
  }

  return (
    <div className="mt-2 rounded-lg bg-gray-50 p-4">
      <div className="space-y-4">
        <div>{body}</div>
      </div>
    </div>
  );
}
